/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export default [
    { width: 1920, height: 1080 },
    { width: 1536, height: 864 },
    { width: 1366, height: 768 },
    { width: 768, height: 1024 },
    { width: 750, height: 1024 },
    { width: 700, height: 1024 },
    { width: 600, height: 1024 },
    { width: 500, height: 1024 },
    { width: 414, height: 896 },
    { width: 375, height: 667 },
    { width: 360, height: 640 },
    { width: 310, height: 556 },
];


// WEBPACK FOOTER //
// ./js/utils/embeds/viewports.ts